// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Upload_uploadContainer__ZxPE5 {
  display: flex;
  flex-direction: column;
  width: 70%;
  justify-content: center;
  align-items: flex-start;
}

.Upload_image__\\+\\+WfI {
  display: flex;
  width: 400px;
  height: auto;
  background: center / cover no-repeat;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
  overflow: hidden;
}

.Upload_image__\\+\\+WfI img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

.Upload_image__\\+\\+WfI:hover img {
  opacity: 0.8;
}

.Upload_imageContainer__sNkl5,
.Upload_emptyContainer__1epHJ {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 34px;
  border: 2px solid #e2e2e2;
  border-radius: 8px;
  background-color: #fcfcfc;
  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);
  box-sizing: border-box;
}

.Upload_emptyContainer__1epHJ {
  justify-content: flex-start;
}

.Upload_imageContainer__sNkl5 {
  justify-content: space-between;
  cursor: pointer;
  transition: border-color 300ms ease-in-out;
}

.Upload_imageContainer__sNkl5:hover {
  border-color: #adadad;
}

.Upload_emptySpan__FtCyZ {
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}

.Upload_icon__8kIl8 {
  width: 24px;
}

.Upload_existingContainer__n7HsX {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  justify-content: center;
  gap: 16px;
  width: 100%;
}

.Upload_profileFormButtons__PcF1j {
  display: flex;
  justify-content: center;
  column-gap: 16px;
  width: 100%;
  position: fixed;
  bottom: 24px;
  left: 0;
  z-index: 99;
}

.Upload_closeButton__o8w2L,
.Upload_saveButton__g\\+9yC,
.Upload_deleteButton__pGT6u,
.Upload_disabledButton__rbrSa,
.Upload_disabledDeleteButton__sVUZq {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  border-radius: 4px;
  cursor: pointer;
}

.Upload_closeButton__o8w2L {
  background-color: #ebebeb;
  width: 164px;
}
.Upload_deleteButton__pGT6u,
.Upload_saveButton__g\\+9yC,
.Upload_disabledButton__rbrSa,
.Upload_disabledDeleteButton__sVUZq {
  width: 212px;
  font-family: Inter;
  color: #fff;
  font-weight: 600;
  transition: 300ms ease-in-out background-color;
}
.Upload_saveButton__g\\+9yC,
.Upload_disabledButton__rbrSa {
  background-color: #cb9c2d;
}
.Upload_deleteButton__pGT6u,
.Upload_disabledDeleteButton__sVUZq {
  background-color: #cb2d2d;
}
.Upload_deleteButton__pGT6u:hover {
  background-color: #8f1c1c;
}
.Upload_saveButton__g\\+9yC:hover {
  background-color: #b38826;
}
.Upload_buttonText__25obv {
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.001em;
  margin: 0;
}
.Upload_btnRow__rWpHZ {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}
.Upload_disabledButton__rbrSa,
.Upload_disabledDeleteButton__sVUZq {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/myProfile/components/Upload/Upload.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf;;qBAEmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oDAAoD;EACpD,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,OAAO;EACP,WAAW;AACb;;AAEA;;;;;EAKE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;;;EAIE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8CAA8C;AAChD;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".uploadContainer {\n  display: flex;\n  flex-direction: column;\n  width: 70%;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.image {\n  display: flex;\n  width: 400px;\n  height: auto;\n  background: center / cover no-repeat;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    opacity 0.2s ease;\n  overflow: hidden;\n}\n\n.image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: inherit;\n}\n\n.image:hover img {\n  opacity: 0.8;\n}\n\n.imageContainer,\n.emptyContainer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 34px;\n  border: 2px solid #e2e2e2;\n  border-radius: 8px;\n  background-color: #fcfcfc;\n  box-shadow: 4px 4px 64px 0px rgba(95, 109, 126, 0.1);\n  box-sizing: border-box;\n}\n\n.emptyContainer {\n  justify-content: flex-start;\n}\n\n.imageContainer {\n  justify-content: space-between;\n  cursor: pointer;\n  transition: border-color 300ms ease-in-out;\n}\n\n.imageContainer:hover {\n  border-color: #adadad;\n}\n\n.emptySpan {\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n\n.icon {\n  width: 24px;\n}\n\n.existingContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  justify-content: center;\n  gap: 16px;\n  width: 100%;\n}\n\n.profileFormButtons {\n  display: flex;\n  justify-content: center;\n  column-gap: 16px;\n  width: 100%;\n  position: fixed;\n  bottom: 24px;\n  left: 0;\n  z-index: 99;\n}\n\n.closeButton,\n.saveButton,\n.deleteButton,\n.disabledButton,\n.disabledDeleteButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 52px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.closeButton {\n  background-color: #ebebeb;\n  width: 164px;\n}\n.deleteButton,\n.saveButton,\n.disabledButton,\n.disabledDeleteButton {\n  width: 212px;\n  font-family: Inter;\n  color: #fff;\n  font-weight: 600;\n  transition: 300ms ease-in-out background-color;\n}\n.saveButton,\n.disabledButton {\n  background-color: #cb9c2d;\n}\n.deleteButton,\n.disabledDeleteButton {\n  background-color: #cb2d2d;\n}\n.deleteButton:hover {\n  background-color: #8f1c1c;\n}\n.saveButton:hover {\n  background-color: #b38826;\n}\n.buttonText {\n  font-family: Inter, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  margin: 0;\n}\n.btnRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n}\n.disabledButton,\n.disabledDeleteButton {\n  cursor: not-allowed;\n  pointer-events: none;\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadContainer": `Upload_uploadContainer__ZxPE5`,
	"image": `Upload_image__++WfI`,
	"imageContainer": `Upload_imageContainer__sNkl5`,
	"emptyContainer": `Upload_emptyContainer__1epHJ`,
	"emptySpan": `Upload_emptySpan__FtCyZ`,
	"icon": `Upload_icon__8kIl8`,
	"existingContainer": `Upload_existingContainer__n7HsX`,
	"profileFormButtons": `Upload_profileFormButtons__PcF1j`,
	"closeButton": `Upload_closeButton__o8w2L`,
	"saveButton": `Upload_saveButton__g+9yC`,
	"deleteButton": `Upload_deleteButton__pGT6u`,
	"disabledButton": `Upload_disabledButton__rbrSa`,
	"disabledDeleteButton": `Upload_disabledDeleteButton__sVUZq`,
	"buttonText": `Upload_buttonText__25obv`,
	"btnRow": `Upload_btnRow__rWpHZ`
};
export default ___CSS_LOADER_EXPORT___;
